<script lang="ts">
    import {FukushimaMinpoService} from "../logics/fukushimaminpo_login_service";
    import Logout from "./Logout.svelte";

    let account = "";
    let password = "";
    let errorMessage = "";
    let fukushimaMinpoService = new FukushimaMinpoService();
    let token = fukushimaMinpoService.getToken();
    if (!(token == null || token.token === undefined || token.token === "" || token.token == null)) {
        fukushimaMinpoService.redirectToApp();
    }


    const fukushima_login = (account: string, password: string) => async function () {
        let response = await fukushimaMinpoService.login(account, password)
        errorMessage = fukushimaMinpoService.parseErrorMessage(response);
        if (errorMessage == "") {
            fukushimaMinpoService.storeToken(response);
            fukushimaMinpoService.redirectToApp();
        }
    }


</script>
<html>
<head>
    <title>福島民報 オンライン新聞 ログイン</title>
    <style>
        @import '/epaper/login.css';
    </style>
</head>
<body>
<div class="log-form">
    <h3>福島民報 オンライン新聞 ログイン</h3>
    <div style="margin-left: 20px; margin-top:15px;">
        <input type="text" title="username" placeholder="電子メールアドレス" bind:value={account}/>
        <input type="password" title="username" placeholder="パスワード" bind:value={password}/>
        <button type="submit" class="btn" on:click={fukushima_login(account,password)}>ログイン</button>
    </div>
    <div style="margin-left: 20px; margin-top:15px;">
        <span style="color: red">{errorMessage}</span>
    </div>
    <!-- <a class="forgot" href="#">Forgot Username?</a> -->
<a href="https://memberservice.minpo.jp/mp-membership/login/init">新規会員登録はこちら</a><br />
<a href="https://memberservice.minpo.jp/mp-membership/changePassword/init">パスワードをお忘れの方はこちら</a>
</div><!--end log form -->



</body>
</html>

